import { ReactNode, useContext, useEffect } from 'react'

import { Box, BoxProps, MantineTheme, Stack, rem } from '@mantine/core'

import { DetectPageReturnType } from 'hooks/useDetectSCpage'
import type { Spotlight } from 'interfaces/types'
import { actionTypes } from 'state/actionTypes'
import { AppContext } from 'state/appContext'

import useStyles from './index.styles'
import type { CarePathColorPattern } from '../../constant'

type WrapperProps = {
  spotlight: Spotlight
  children: ReactNode
  activeTheme: CarePathColorPattern
  detectPage: DetectPageReturnType
} & BoxProps

const Wrapper = ({
  activeTheme,
  spotlight,
  children,
  detectPage,
  className,
  styles,
  classNames,
  ...boxProps
}: WrapperProps) => {
  const { dispatch } = useContext(AppContext)
  const { isRoche } = detectPage
  const { classes, cx } = useStyles(
    {
      primaryColor: activeTheme.primary || '',
      bodyColor: isRoche ? '#FBF0F3' : undefined,
      detectPage,
    },
    {
      name: 'CarePathDefaultTemplate__Wrapper',
      styles,
      classNames,
    },
  )

  useEffect(() => {
    spotlight?.integrates3rdParty?.zaloConfig?.oaid &&
      dispatch({
        type: actionTypes.SET_ZALO_CONFIG,
        payload: {
          oaid: spotlight.integrates3rdParty.zaloConfig.oaid,
          message: 'rất vui được hỗ trợ bạn.',
        },
      })
    spotlight?.integrates3rdParty?.chatwoodToken &&
      dispatch({
        type: actionTypes.SET_CHATWOOT_WEBSITE_TOKEN,
        payload: spotlight.integrates3rdParty.chatwoodToken,
      })

    return () => {
      dispatch({
        type: actionTypes.SET_ZALO_CONFIG,
        payload: null,
      })
      dispatch({
        type: actionTypes.SET_CHATWOOT_WEBSITE_TOKEN,
        payload: null,
      })
    }
  }, [])

  return (
    <>
      <Box className={cx(className, classes.root)} {...boxProps}>
        <Stack
          sx={(theme: MantineTheme) => ({
            gap: 0,
            '[data-none-bg-session="true"]': {
              padding: `${rem(40)} 0`,
            },
            '[data-none-bg-session="true"] + [data-none-bg-session="true"]': {
              paddingTop: 0,
            },
            [theme.fn.largerThan('sm')]: {
              '[data-none-bg-session="true"]': {
                padding: `${rem(80)} 0`,
              },
            },
          })}
        >
          {children}
        </Stack>
      </Box>
    </>
  )
}

export { Wrapper }
